import { useRef } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useTracker } from '../tracking/useTracker';
import { Button as SidePanelButton, Root as SidePanelRoot, Text as SidePanelText } from 'signup-components/components/OAuthButton/OAuthButton';
import { useGoogleIdentityServices } from './useGoogleIdentityServices';
import { useGoogleLoginNonce } from './useGoogleLoginNonce';
import { useLoadGoogleIdentityServices } from './useLoadGoogleIdentityServices';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { SocialGoogleIcon } from 'foundations-assets/icons/components/SocialGoogleIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GoogleOAuthButton = () => {
  const googleButtonRef = useRef(null);
  const {
    googleSignInNonce,
    didNonceRequestFail
  } = useGoogleLoginNonce();
  const Tracker = useTracker();
  const onAuthenticationFailed = failure => Tracker.signupInteraction(`google-oauth-exception-${failure.reason}`);
  const {
    isLoading,
    isLoaded
  } = useLoadGoogleIdentityServices({
    onAuthenticationFailed
  });
  const isGoogleLibraryLoaded = !isLoading || isLoaded;
  useGoogleIdentityServices({
    googleButtonRef,
    libraryHasLoaded: isGoogleLibraryLoaded,
    googleSignInNonce,
    style: 'outline'
  });
  if (didNonceRequestFail) {
    return /*#__PURE__*/_jsx(SidePanelRoot, {
      marginInline: "auto",
      maxInlineSize: "420px",
      paddingInline: "400",
      provider: OAuthProviders.Google,
      useBrandColors: false,
      children: /*#__PURE__*/_jsxs(SidePanelButton, {
        "aria-disabled": true,
        "data-test-id": "oauth-button-google-fallback",
        disabled: true,
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: SocialGoogleIcon,
          marginInlineStart: "100",
          padding: "0",
          size: "600"
        }), /*#__PURE__*/_jsx(SidePanelText, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'views.LANDING_PAGE.googleSignup'
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(SidePanelRoot, {
    "data-test-id": "oauth-button-google",
    id: "google-oauth-container",
    marginInline: "auto",
    maxInlineSize: "420px",
    paddingInline: "400",
    provider: OAuthProviders.Google,
    useBrandColors: false,
    children: isGoogleLibraryLoaded ? /*#__PURE__*/_jsx(SidePanelButton, {
      id: "g_id_onload",
      ref: googleButtonRef
    }) : /*#__PURE__*/_jsx(SidePanelButton, {
      children: /*#__PURE__*/_jsx(SidePanelText, {
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "sm"
        })
      })
    })
  });
};